module.exports = __webpack_public_path__ + "static/img/girl-1.9a7490d5.png";